document.addEventListener("DOMContentLoaded", function () {
  const addressInput = document.getElementById("address1");
  if (!addressInput) return;

  const autocomplete = new google.maps.places.Autocomplete(addressInput, {
    types: ["address"],
    fields: ["address_components", "geometry"],
  });

  autocomplete.addListener("place_changed", function () {
    const place = autocomplete.getPlace();
    if (!place.address_components) return;

    const componentForm = {
      street_number: "short_name",
      route: "long_name",
      locality: "long_name", // city
      administrative_area_level_1: "short_name", // state
      country: "short_name",
      postal_code: "short_name", // zip
    };

    const address = {
      street_number: "",
      route: "",
      city: "",
      state: "",
      zip: "",
      country: "",
    };

    place.address_components.forEach(component => {
      const addressType = component.types[0];
      if (componentForm[addressType]) {
        const val = component[componentForm[addressType]];
        switch (addressType) {
          case "street_number":
            address.street_number = val;
            break;
          case "route":
            address.route = val;
            break;
          case "locality":
            address.city = val;
            break;
          case "administrative_area_level_1":
            address.state = val;  // store, don't set select here
            break;
          case "postal_code":
            address.zip = val;
            break;
          case "country":
            address.country = val;
            break;
        }
      }
    });

    // Fill address line 1
    addressInput.value = `${address.street_number} ${address.route}`.trim();

    // Fill city and zip
    document.getElementById("city").value = address.city;
    document.getElementById("zip").value = address.zip;

    // Set country select
    const countrySelect = document.getElementById("account_country");
    if (countrySelect) countrySelect.value = address.country;

    // Store desired state code in data attribute for later selection
    const stateSelect = document.getElementById("account_state");
    if (stateSelect) {
      stateSelect.setAttribute("data_attr", address.state);
    }

    // Call your existing country change handler to fetch states and select correct one
    if (typeof window.handleCountryChange === "function") {
      window.handleCountryChange();
    }
  });
});